import React, { Component } from 'react'
import { connect } from 'react-redux'

import { Snackbar } from '@material-ui/core'
import { loadSiteApplications, verifyAuthorization } from '../actions/siteapplications'

import SignUpForEnterprise from './SignUpForEnterprise.component'
import { Box, withInfinateSpin, SwxTheme } from 'swx-atomic-component-lib'
import SpinnerIcon from 'calcite-ui-icons-react/SpinnerIcon'
import {
  checkLoggedin,
  verifyAndSendToken,
  loadImage
} from '../actions/users'

import { hideNotification } from '../actions/notifications'
import AppSwitcherImpl from '../components/common/AppSwitcherImpl.component'

class AppLauncher extends Component {
  constructor (props) {
    super(props)
    this.user = this.props.self.user || {}
    this.appsVerified = 0
    this.state = {
      first_name: this.user.first_name,
      last_name: this.user.last_name,
      enterprise: this.user.Enterprise,
      siteApplications: [],
      isProcessing: true,
      allAppsVerified: false
    }
  }

  componentDidMount = () => {
    this.setState({ isProcessing: true })
    this.props.loadSiteApplications().then(() => {
      this.setState({ isProcessing: false, siteApplications: this.props.siteApplication.items })
    })
  }

  handleOnSnackbarClose = (e) => {
    this.props.hideNotification()
  }

  handleOnLaunchClick = (app, e) => {
    e.preventDefault()
    if (app.disabled) {
      if (app.theme === 'primary') {
        window.open('https://www.smarterwx.com/smarterwx-automate')
      } else if (app.theme === 'yellow') {
        window.open('https://www.smarterwx.com/smarterwx-collaborate ')
      } else if (app.theme === 'primary-alt') {
        window.open('https://www.smarterwx.com/smarterwx-locate ')
      } else if (app.isAppDown) {
        window.location.href = `/app-down?name=${app.name}`
      }
    } else {
      this.setState({ isProcessing: true })
      this.props.verifyAndSendToken(app.client_id).then((response) => {
        if (response.value.data.siteApplication.postCallbackUrl) {
          const form = document.createElement('form')
          document.body.appendChild(form)
          form.method = 'POST'
          form.action = response.value.data.siteApplication.postCallbackUrl

          const tokenInput = document.createElement('input')
          tokenInput.name = 'token'
          tokenInput.type = 'hidden'
          tokenInput.value = response.value.data.token
          form.appendChild(tokenInput)
          form.submit()

          return
        }

        const newQs = `token=${this.props.self.token}`
        window.location.href = `${app.base_url}${app.callback_url}?${newQs}`
      }, err => {
        console.error('onEditClick', err)
      })
    }
  }

  checkAllAppsVerified = () => {
    this.appsVerified++
    if (this.appsVerified >= this.state.siteApplications.length) {
      this.setState({ allAppsVerified: true })
    }
  }

  render () {
    if (this.state.isProcessing) {
      return null
    }

    return (
      <>
        <Box w='100%' display='flex' justifyContent='center'>
          {
            (!this.state.allAppsVerified) && (
              withInfinateSpin(SpinnerIcon, { size: SwxTheme.sizing.x4 })
            )
          }
          <Box w='60%' display={this.state.allAppsVerified ? 'block' : 'none'}>
            {
              this.state.siteApplications && this.state.siteApplications.map(app => {
                return (
                  <AppSwitcherImpl
                    key={app.client_id}
                    data={app}
                    verifyAuthorization={verifyAuthorization}
                    checkAllAppsVerified={this.checkAllAppsVerified}
                    onClick={this.handleOnLaunchClick}
                  />
                )
              })
            }
          </Box>
        </Box>
        {
          <Snackbar
            anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            open={this.props.notification && this.props.notification.showNotification}
            autoHideDuration={3000}
            onClose={this.handleOnSnackbarClose}
            ContentProps={{
              'aria-describedby': 'message-id'
            }}
            message={<span id='message-id'>{this.props.notification && this.props.notification.text}</span>}
          />
        }

        {
          (this.user.Enterprise && this.user.role !== 'SYSADMIN') || !this.state.allAppsVerified
            ? null
            : <SignUpForEnterprise />
        }

      </>
    )
  }
}

function mapStateToProps (state) {
  return {
    self: state.self,
    notification: state.notification,
    siteApplication: state.siteApplication
  }
}

export default connect(mapStateToProps, {
  loadSiteApplications,
  checkLoggedin,
  verifyAndSendToken,
  hideNotification,
  loadImage
})(AppLauncher)
